<nav class="ds-legal__related" aria-label="İlgili yasal metinler">
  <h2>İlgili Metinler</h2>
  <ul>
    <li><a routerLink="/aydinlatma-metni" routerLinkActive="is-current">Aydınlatma Metni</a></li>
    <li><a routerLink="/cerez-bilgilendirme-metni" routerLinkActive="is-current">Çerez Bilgilendirme Metni</a></li>
    <li><a routerLink="/acik-riza-metni" routerLinkActive="is-current">Açık Rıza Metni</a></li>
  </ul>
</nav>
